const FormError = (props?: any) => {
  return (
    <span className={`text-danger font-italic ${props.classes}`}>
      {props.message}
    </span>
  );
};

export default FormError;
